import React, { createContext, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userType, setUserType] = useState(null);
  const navigate = useNavigate();
  const location = useLocation(); // Get the current location

  useEffect(() => {
    const jwt = sessionStorage.getItem('jwt');
    const type = sessionStorage.getItem('user_type');

    if (jwt && type) {
      setIsAuthenticated(true);
      setUserType(type);

      // Check if the current location is not the login page
      if (location.pathname === '/login') {
        // Redirect to appropriate route based on userType
        if (type === '1') {
          navigate('/admin');
        } else if (type === '2') {
          navigate('/staff');
        } else if (type === '3') {
          navigate('/student');
        } else if (type === '4') {
          navigate('/guardian');
        }
      }
    } else {
      setIsAuthenticated(false);
      setUserType(null);
      if (location.pathname !== '/login') {
        navigate('/login');
      }
    }
  }, [navigate, location.pathname]);

  const login = (jwt, userId, userType) => {
    sessionStorage.setItem('jwt', jwt);
    sessionStorage.setItem('user_id', userId);
    sessionStorage.setItem('user_type', userType);

    setIsAuthenticated(true);
    setUserType(userType);

    // Redirect based on userType
    if (userType === '1') {
      navigate('/admin');
    } else if (userType === '2') {
      navigate('/staff');
    } else if (userType === '3') {
      navigate('/student');
    } else if (userType === '4') {
      navigate('/guardian');
    }
  };

  const logout = () => {
    sessionStorage.clear();
    setIsAuthenticated(false);
    setUserType(null);
    navigate('/login');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, userType, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
